import styled from 'styled-components';
import { Label, Text, spaceMixin } from '@zillow/constellation';

export const StyledUppercaseText = styled(Text)`
    text-transform: uppercase;
`;

export const StyledLabel = styled(Label)`
    margin-bottom: ${spaceMixin('xs')};
`;
